import { DateInput } from '@heroui/react'
import { getLocalTimeZone, today } from '@internationalized/date'
import PathwaySelect from 'components/Hero/PathwaySelect'
import PhoneInput from 'components/Hero/PhoneInput'
import { KVInput, TagsSelect } from '../inputs'

export const smsFilterableFields = {
  conversation_id: { label: 'Conversation ID', operators: ['equals', 'not'] },
  user_number: { label: 'User Number', operators: ['equals', 'not'], inputComponent: PhoneInput },
  agent_number: { label: 'Agent Number', operators: ['equals', 'not'], inputComponent: PhoneInput },
  curr_pathway_id: { label: 'Current Pathway', operators: ['equals', 'not'], inputComponent: PathwaySelect },
  pathway_tags: { label: 'Pathway Tags', operators: ['hasSome', 'none'], inputComponent: TagsSelect },
  created_at: { label: 'Created Date', operators: ['equals', 'gt', 'lt', 'gte', 'lte'], inputComponent: DateInput, inputProps: { defaultValue: today(getLocalTimeZone()) } },
  last_message_at: { label: 'Last Message Date', operators: ['equals', 'gt', 'lt', 'gte', 'lte'], inputComponent: DateInput, inputProps: { defaultValue: today(getLocalTimeZone()) } },
  message_count: { label: 'Message Count', operators: ['equals', 'gt', 'lt', 'gte', 'lte'], inputProps: { type: 'number', placeholder: '0' } },
  variables: { label: 'Variables', operators: ['hasSome', 'none'], inputComponent: KVInput },
}
